// extracted by mini-css-extract-plugin
export default {"colors":"x60HbAyrk5tfCtZ6booN","wrapper":"xLzvTMUqfiENFi5cKmz8","dialog__item":"rV8xEW4clxY5GExhdvo2","value":"fs4IzQC2Gw6W2ZGBnXKz","text":"SUpvAXMd_oj4gJF9sKrf"};